module.exports = __webpack_public_path__ + "img/pic_bank_ABC@2x.d819af8d.png";